import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { DomainService } from '../../../services/domain.service';
import { group_by_item_count } from '../../../../functions';

@Component({
  selector: 'app-home-what-we-do-section',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, NgbCarouselModule],
  templateUrl: './home-what-we-do-section.component.html',
})
export class HomeWhatWeDoSectionComponent {
  readonly domain = inject(DomainService);

  partnerSliderBE = {
    options: { showCaption: false },
    slides: [
      {
        title: 'VKW Limburg',
        image_url: 'assets/img/logo/partners/be/vkwlimburg-logo.png',
        url: 'https://www.vkwlimburg.be/',
      },
      {
        title: 'VDAB',
        image_url: 'assets/img/logo/partners/be/vdab-logo.png',
        url: 'https://www.vdab.be/',
      },
      {
        title: 'POM Limburg',
        image_url: 'assets/img/logo/partners/be/limburg-be.png',
        url: 'https://www.pomlimburg.be',
      },
    ],
    slides_desktop: [] as any[],
    slides_mobile: [] as any[],
  };

  partnerSliderNL = {
    options: { showCaption: false },
    slides: [
      {
        title: 'AgroLeeft',
        image_url: 'assets/img/logo/partners/nl/agroleeft_big.86f5b099.png',
        url: 'https://www.agroleeft.nl',
      },
      {
        title: 'Brightlands',
        image_url: 'assets/img/logo/partners/nl/brightlands-logo-animatie.jpg',
        url: 'https://www.brightlands.com',
      },
      {
        title: 'Crossroads Limburg',
        image_url: 'assets/img/logo/partners/nl/Crossroads.jpg',
        url: 'https://crossroadslimburg.com',
      },
      {
        title: 'Economische Samenwerking Zuid-Limburg',
        image_url: 'assets/img/logo/partners/nl/Economische_SZL.jpg',
        url: 'https://eszl.nl',
      },
      {
        title: 'Etil research group',
        image_url: 'assets/img/logo/partners/nl/Etil.png',
        url: 'https://www.etil.nl',
      },
      {
        title: 'Keyport',
        image_url: 'assets/img/logo/partners/nl/Keyport-logo-compact2023.jpg',
        url: 'https://www.keyport.nl',
      },
      {
        title: 'LWV',
        image_url: 'assets/img/logo/partners/nl/LWV.png',
        url: 'https://www.lwv.nl',
      },
      {
        title: 'MKB Limburg',
        image_url: 'assets/img/logo/partners/nl/MKB-L.png',
        url: 'https://www.mkblimburg.nl',
      },
      {
        title: 'Regio in je Rugzak',
        image_url: 'assets/img/logo/partners/nl/RIJR.jpg',
        url: 'https://regioinjerugzak.nl',
      },
      {
        title: 'Servicepunt Werkgevers',
        image_url: 'assets/img/logo/partners/nl/servicepunt_werkgevers.png',
        url: 'https://www.werkgeversservicepunten.nl',
      },
      {
        title: 'Sterk Techniekonderwijs',
        image_url: 'assets/img/logo/partners/nl/STO.png',
        url: 'https://www.sterktechniekonderwijs.nl',
      },
      {
        title: 'Supply Chain Valley',
        image_url: 'assets/img/logo/partners/nl/supply_chain_valley.jpg',
        url: 'https://supplychainvalley.com',
      },
    ],
    slides_desktop: [] as any[],
    slides_mobile: [] as any[],
  };

  constructor() {
    this.partnerSliderBE.slides_desktop = group_by_item_count(this.partnerSliderBE.slides, 3);
    this.partnerSliderBE.slides_mobile = group_by_item_count(this.partnerSliderBE.slides, 2);

    this.partnerSliderNL.slides_desktop = group_by_item_count(this.partnerSliderNL.slides, 3);
    this.partnerSliderNL.slides_mobile = group_by_item_count(this.partnerSliderNL.slides, 2);
  }
}
